import Accordion from "./components/accordion.js";
import BackToTopButton from "./components/backToTopButton.js";
import courseFilters from "./components/courseFilters.js";
//import DocCheck from "./components/docCheck.js";
import handleMultipleCategories from "./components/handleMultipleCategories.js";
import HelloComponent from "./components/helloComponent.js";
import MobileColumnsSlider from "./components/mobileColumnsSlider.js";
import QueryLoopSlider from "./components/queryLoopSlider.js";
import SliderColumnAllDevices from "./components/sliderColumnAllDevices.js";

class Main {
    static init() {
        this.hello();
        new HelloComponent();
        jQuery(document).ready(function ($) {
            // console.log("Hello from jQuery");
        });

        new Accordion();

        new QueryLoopSlider();

        new MobileColumnsSlider();

        new SliderColumnAllDevices();

        new BackToTopButton();

        // new DocCheck();

        handleMultipleCategories();

        courseFilters();

        this.rangBackButton();
    }
    static hello() {
        // console.log("Hello World!");
    }

    static rangBackButton() {
        // create backButton
        const backButton = document.createElement("button");
        backButton.classList.add("back-button");
        backButton.innerHTML =
            '<i class="bb-icon-l bb-icon-angle-double-left"></i> Zurück';
        backButton.setAttribute("aria-label", "Back to previous page");
        backButton.setAttribute("type", "button");
        backButton.setAttribute("id", "back-button");

        // append backButton if body has class "single-rang" to article width class "rang"
        const body = document.querySelector("body");
        const article = document.querySelector("article.rang");
        if (body.classList.contains("single-rang") && article) {
            article.appendChild(backButton);
        }

        if (backButton) {
            backButton.addEventListener("click", function (event) {
                event.preventDefault();
                window.history.back();
            });
        }
    }
}

Main.init();
